export default {
  alcohol: 'Alcohol',
  beverages: 'Beverages',
  addons: 'Addons',
  ingredient: 'Ingredient',
}
